import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut, AlertTriangle } from 'lucide-react';
import authService from '../../services/authService';

const SessionExpired = ({ setIsAuthenticated }) => {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useTranslation();

  const hideOverlay = () => setIsVisible(false);

  const handleSessionExpiration = async () => {
    try {
      await authService.logout();
      sessionStorage.removeItem('user');
      setIsAuthenticated(false);
      document.cookie.split(';').forEach(cookie => {
        document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      });
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  // Call handleSessionExpiration when component mounts
  useEffect(() => {
    handleSessionExpiration();
    // Empty dependency array means this only runs once when mounted
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 dark:bg-gray-900/75 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl dark:shadow-gray-900/20 p-8 max-w-md w-full mx-4">
        <div className="flex justify-center mb-6">
          <AlertTriangle className="h-16 w-16 text-yellow-500" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4 text-center">
          {t('Session Expired')}
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-8 text-center">
          {t('Your session has expired. Please log in again.')}
        </p>
        <div className="flex justify-center">
          <Link
            to="/login"
            onClick={hideOverlay}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm dark:shadow-gray-900/20 text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition duration-150 ease-in-out"
          >
            <LogOut className="mr-2 -ml-1 h-5 w-5" />
            {t('Go to Login')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;